import {
  ApiConfig
} from "./chunk-LPIRJEMY.mjs";
import {
  __async,
  __spreadProps,
  __spreadValues
} from "./chunk-DFMI36TU.mjs";

// src/core/wbk/client.ts
import { readCookie } from "@wbk/utils";
var fetchClient = (_0) => __async(void 0, [_0], function* ({
  baseUrl,
  url,
  options,
  raw,
  formData,
  includeAuth = true,
  includeToken = true,
  version
}) {
  var _a;
  const wbkConfig = (_a = ApiConfig.config) == null ? void 0 : _a.wbk;
  if (!baseUrl && !wbkConfig) {
    const msg = "WBK `ApiConfig` was not initialized. See instructions in https://github.com/nadude/webook-frontend/blob/main/packages/api/README.md";
    console.error(msg);
    throw new Error(msg);
  }
  let api = wbkConfig == null ? void 0 : wbkConfig.api;
  if (version === "v1") {
    api = api == null ? void 0 : api.replace("v2", "v1");
  }
  const base = baseUrl || api;
  const endPoint = url.startsWith("/") ? url : `/${url}`;
  const token = readCookie("token") || "";
  const headers = __spreadValues(__spreadProps(__spreadValues(__spreadValues({}, includeToken && { token: wbkConfig == null ? void 0 : wbkConfig.apiToken }), includeAuth && { Authorization: `Bearer ${token}` }), {
    Accept: "application/json"
  }), options == null ? void 0 : options.headers);
  const response = yield fetch(`${base}${endPoint}`, __spreadProps(__spreadValues({}, options), {
    headers: formData ? headers : __spreadValues({ "Content-Type": "application/json" }, headers)
  }));
  if (raw) {
    return response;
  }
  const res = yield response.json();
  if (!response.ok) {
    if (!res.message) {
      res.message = (res == null ? void 0 : res.error) || "Something went wrong";
    }
    res.statusCode = response.status;
    throw res;
  }
  return res;
});

export {
  fetchClient
};
//# sourceMappingURL=chunk-K342ITN7.mjs.map